exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".applicant[data-v-6189c91c]{border-left:4px solid #1976d2!important}", ""]);

// exports
